import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";
import classNames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import FinalSaleTag from "component/product/V2/image-section/FinalSaleTag";
import WasPrice from "modules/components/prices/was-price/WasPrice";
import { useRouter } from "next/router";
import { getCentAmount } from "util/helper/getCentAmount";
import { parseDollarAmt } from "util/helper/parseDollarAmt";
import { savingsPercentage, showSavingsPercentage } from "util/helper/priceDifference";
import HideIf from "util/HideIf";
import styles from "./styles.module.scss";

interface IProps {
  product: ICompactProduct;
  isListView?: boolean;
}

function CategoryPrice({ product, isListView = false }: IProps) {
  const { locale } = useRouter();

  return (
    <div className={classNames(styles.category_price_container, { [styles.category_price_list]: isListView })}>
      <div className="d-flex align-items-center">
        <HideIf show={locale === "en"}>
          <PAText className={`${styles.category_price_label} m-r-5`}>
            CA$
          </PAText>
        </HideIf>
        <PAText bold className={styles.category_price}>
          {`${parseDollarAmt(product.price)}.${getCentAmount(product.price)}`}
        </PAText>
        <HideIf show={locale === "fr"}>
          <PAText className={`${styles.category_price_label} m-l-5`}>
            CA$
          </PAText>
        </HideIf>
      </div>
      <div className={styles.savings_container}>
        <WasPrice product={product} compact />
        <HideIf show={showSavingsPercentage(product.wasPrice, product.price)}>
          <div className={styles.short_saved_price}>
            <PAText fontSize={FONT_SIZE[0]}>
              {savingsPercentage(product.wasPrice, product.price)}
            </PAText>
          </div>
        </HideIf>
      </div>
      <div className={styles.final_sale_wrapper}>
        <FinalSaleTag product={product} className={styles.final_sale} />
      </div>
    </div>
  );
}
export default CategoryPrice;
